/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリースPDFファイルアップロード成功時のレスポンスデータ
 * @export
 * @interface PostPressReleasePdfFileSuccessResponseData
 */
export interface PostPressReleasePdfFileSuccessResponseData {
    /**
     * サーバーに保存されたファイルの名前
     * @type {string}
     * @memberof PostPressReleasePdfFileSuccessResponseData
     */
    pdfFileName: string;
}

export function PostPressReleasePdfFileSuccessResponseDataFromJSON(json: any): PostPressReleasePdfFileSuccessResponseData {
    return PostPressReleasePdfFileSuccessResponseDataFromJSONTyped(json, false);
}

export function PostPressReleasePdfFileSuccessResponseDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostPressReleasePdfFileSuccessResponseData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'pdfFileName': json['pdf_file_name'],
    };
}

export function PostPressReleasePdfFileSuccessResponseDataToJSON(value?: PostPressReleasePdfFileSuccessResponseData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'pdf_file_name': value.pdfFileName,
    };
}

